module.exports = __webpack_public_path__ + "static/media/sb_tip1.9c69e3a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FlightsHome/img/sb_tip1.jpg
// module id = 542
// module chunks = 0